import React from "react";

import { Divider } from "semantic-ui-react";

import useCurrentUser from "data/advisor/useCurrentUser";
import useHub from "data/hub/useHub";

import Access from "components/Access";

import {
  HubInformationForm,
  PracticeInformation,
  Subscription,
} from "./components";

function AccountSettings() {
  const user = useCurrentUser();
  const selectedHub = useHub();

  return (
    <React.Fragment>
      <PracticeInformation />

      <Divider style={{ marginTop: "2em", marginBottom: "1em" }} />

      <HubInformationForm advisor={user} />

      <Divider style={{ marginTop: "2em", marginBottom: "1em" }} />

      <Access required={["Administrator"]}>
        <Subscription practiceId={selectedHub.practice} user={user} />
      </Access>
    </React.Fragment>
  );
}

export default AccountSettings;
